import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-688d63d1"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "box" }
const _hoisted_2 = { class: "layout-list" }
const _hoisted_3 = { class: "left-box" }
const _hoisted_4 = { class: "black title" }
const _hoisted_5 = { class: "grey" }

import { getDeliveryLogList } from '@/apis/projectDetail'
import _lodash from '@/utils/lodashUtil'
import { onMounted, reactive, ref, watch } from 'vue'
import { useRouter } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter()
const state = reactive({
  project_id: null,
  page: 1,
  deliverList: []
})
const loading = ref(false)
const finished = ref(false)
const refreshing = ref(false)

const get_delivery_List = async () => {
  let data = {
    page: state.page,
    page_size: 10,
    project_id: state.project_id
  }
  const res = await getDeliveryLogList(data)
  if (res.code === 200) {
    finished.value = false
    if (refreshing.value) {
      state.deliverList = []
      refreshing.value = false
    }
    state.page += 1
    state.deliverList = _lodash.uniq(_lodash.concat(state.deliverList, res.data.data))
    loading.value = false
    if (state.page > res.data.last_page) {
      // 已到最后一页
      finished.value = true
    }
    console.log(state.deliverList)
  }
}
const onRefresh = () => {
  // 清空列表数据
  finished.value = false
  state.page = 1
  // 重新加载数据
  // 将 loading 设置为 true，表示处于加载状态
  loading.value = true
  get_delivery_List()
}

onMounted(() => {
  state.project_id = Number(router.currentRoute.value.query.project_id)
})

return (_ctx: any,_cache: any) => {
  const _component_base_nav_bar = _resolveComponent("base-nav-bar")!
  const _component_van_list = _resolveComponent("van-list")!
  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_base_nav_bar, {
      title: _ctx.$route.meta.title,
      "left-text": "返回"
    }, null, 8, ["title"]),
    _createVNode(_component_van_pull_refresh, {
      modelValue: refreshing.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((refreshing).value = $event)),
      onRefresh: onRefresh
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_list, {
          loading: loading.value,
          "onUpdate:loading": _cache[0] || (_cache[0] = ($event: any) => ((loading).value = $event)),
          finished: finished.value,
          "finished-text": "没有更多了",
          onLoad: get_delivery_List
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).deliverList, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "row row-layout-box",
                  key: item
                }, [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, _toDisplayString(item.title) + _toDisplayString(item.num) + _toDisplayString(item.uniti), 1),
                    _createElementVNode("div", _hoisted_5, "发货截至时间 " + _toDisplayString(item.arrival_time.substring(0, 10)), 1)
                  ])
                ]))
              }), 128))
            ])
          ]),
          _: 1
        }, 8, ["loading", "finished"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})